import React, { useMemo } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";

import { ApolloClient, ApolloProvider, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { MutableResultCache } from "./MutableResultCache";
import { resolvers, typeDefs } from "../graphql/resolvers";
import { setConnectionState } from "../redux/actions/actions";

const ApolloWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();

  // One client per session: recreating it on every render would throw away the cache.
  const client = useMemo(() => {
    const authLink = setContext(async (_, { headers, ...rest }) => {
      const token = await getAccessTokenSilently();
      return {
        ...rest,
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      };
    });

    const errorLink = onError(({ graphQLErrors, networkError, response, operation }) => {
      console.log("error afterware, graphQLErrors: ", graphQLErrors);
      console.log("error afterware, networkError: ", networkError);
      console.log("error afterware, response: ", response);
      console.log("error afterware, operation: ", operation);

      if (networkError && !navigator.onLine) {
        dispatch(setConnectionState(true));
      }
    });

    const httpLink = createUploadLink({ uri: window.localStorage.serverUrl });

    return new ApolloClient({
      link: from([authLink, errorLink, httpLink as any]),
      cache: new MutableResultCache(),
      typeDefs,
      resolvers,
    });
  }, [getAccessTokenSilently, dispatch]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloWrapper;
